export default {
  NODE_ENV: process.env.NODE_ENV,
  BASE_URL: process.env.BASE_URL,
  BASE_URL_API: process.env.VUE_APP_BASE_URL_API,
  CHATBOT_BASIC_ID: process.env.VUE_APP_CHATBOT_BASIC_ID,
  LINE_LIFF_ID: process.env.VUE_APP_LINE_LIFF_ID,
  LINE_AGENCY_FACEBOOK_PAGE_ID: process.env.VUE_APP_LINE_AGENCY_FACEBOOK_PAGE_ID,
  GOOGLE_ANALYTICS_ID: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
  GOOGLE_TAG_ID: process.env.VUE_APP_GOOGLE_TAG_ID,
  K_PAYMENT_URL: process.env.VUE_APP_K_PAYMENT_URL,
  K_PAYMENT_API_KEY: process.env.VUE_APP_K_PAYMENT_API_KEY,
  K_PAYMENT_MERCHANT_ID: process.env.VUE_APP_K_PAYMENT_MERCHANT_ID
}
